import appConfig from 'app-config';
import _ from 'lodash';

const SI_STATUS_NAME = 'configuration.portal.producerengage.si.status';
const SS_STATUS_NAME = 'configuration.portal.producerengage.ss.status';
const SI_MAX_NUMBER_OF_DRIVER_NAME = 'configuration.portal.producerengage.ss.driver.max';
const SS_MAX_NUMBER_OF_VEHICLE_NAME = 'configuration.portal.producerengage.ss.vehicle.max';
const SI_MAX_NUMBER_OF_LOCATION_NAME = 'configuration.portal.producerengage.ss.location.max';

/**
 * submissionIntakeStatus: the status which can continue to submission intake
 * spreadSheetIntakeStatus: the status which can continue to spreadsheet intake
 * @returns the status which can continue
 */
function getContinueStatus(useBusinessData) {
    const { runtimeProperties } = useBusinessData;

    const submissionIntakeStatus = _.find(
        runtimeProperties,
        (property) => _.get(property, 'name') === SI_STATUS_NAME
    );
    
    const spreadSheetIntakeStatus = _.find(
        runtimeProperties,
        (property) => _.get(property, 'name') === SS_STATUS_NAME
    );

    const submissionIntakeStatusValue = _.get(submissionIntakeStatus, 'value', '');
    const spreadSheetIntakeStatusValue = _.get(spreadSheetIntakeStatus, 'value', '');

    return {
        submissionIntakeStatus: _.split(submissionIntakeStatusValue, ','),
        spreadSheetIntakeStatus: _.split(spreadSheetIntakeStatusValue, ','),
    }
}

function getMaxNumberSettings(useBusinessData) {    
    // POI-60579 UAT Finding - SI - Add Reminder message display in Spreadsheet upload pop up
    // default value Driver: 200, Vehicle: 80, Location: 20 for now as a temporaray solution
    const { runtimeProperties } = useBusinessData;

    const spreadSheetIntakeMaxNumberOfDriver = _.find(
        runtimeProperties,
        (property) => _.get(property, 'name') === SI_MAX_NUMBER_OF_DRIVER_NAME
    );

    const spreadSheetIntakeMaxNumberOfVehicle = _.find(
        runtimeProperties,
        (property) => _.get(property, 'name') === SS_MAX_NUMBER_OF_VEHICLE_NAME
    );

    const spreadSheetIntakeMaxNumberOfLocation = _.find(
        runtimeProperties,
        (property) => _.get(property, 'name') === SI_MAX_NUMBER_OF_LOCATION_NAME
    );
    
    const maxNumberOfDriver = _.get(spreadSheetIntakeMaxNumberOfDriver, 'value', 200);
    const maxNumberOfVehicle = _.get(spreadSheetIntakeMaxNumberOfVehicle, 'value', 50);
    const maxNumberOfLocation = _.get(spreadSheetIntakeMaxNumberOfLocation, 'value', 30);

    return {
        maxNumberOfDriver: maxNumberOfDriver,
        maxNumberOfVehicle: maxNumberOfVehicle,
        maxNumberOfLocation: maxNumberOfLocation
    }
}


const { submissionIntakeConfig, routerBaseName } = appConfig;
let submissionIntakeURL;
if (
    _.get(submissionIntakeConfig, 'REACT_APP_UP_SPA_URL') !==
    '{{REACT_APP_UP_SPA_URL}}'
) {
    submissionIntakeURL = `upspa@${_.get(
        submissionIntakeConfig,
        'REACT_APP_UP_SPA_URL'
    )}`;
}

let deploymentId;
if (_.get(submissionIntakeConfig, 'DEPLOYMENT_ID') !== '{{DEPLOYMENT_ID}}') {
    deploymentId = _.get(submissionIntakeConfig, 'DEPLOYMENT_ID');
}

let lifecycleserviceURL;
if (
    _.get(submissionIntakeConfig, 'LIFE_CYCLE_SERVICE_URL') !==
    '{{LIFE_CYCLE_SERVICE_URL}}'
) {
    lifecycleserviceURL = _.get(
        submissionIntakeConfig,
        'LIFE_CYCLE_SERVICE_URL'
    );
}

function getConfigs() {
    return {
        submissionIntakeURL,
        deploymentId,
        routerBaseName,
        lifecycleserviceURL,
        getContinueStatus,
        getMaxNumberSettings
    };
}

function generateModalCallbackMap(callbackMap, onReject = _.noop) {
    const modalCallbackMap = {};
    _.each(callbackMap, (cb, key) => {
        if (_.isFunction(cb)) {
            modalCallbackMap[key] = cb;
        } else if (_.isFunction(_.get(cb, 'call'))) {
            if (_.get(cb, 'needModalOnReject') === true) {
                const cbFunctionWithOnReject = (...params) => {
                    _.get(cb, 'call')(params);
                    onReject();
                };
                modalCallbackMap[key] = cbFunctionWithOnReject;
            } else {
                modalCallbackMap[key] = _.get(cb, 'call');
            }
        }
    });
    return modalCallbackMap;
}

export default {
    getConfigs,
    generateModalCallbackMap
};
